import type { FC, Dispatch } from "react";

import styled from "styled-components";

import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { CheckboxFilter } from "../../../../components/filters/CheckboxFilter";
import type { FilterAction, FilterState } from "../utils/filtersReducer";

const Container = styled(FlexRow)`
    gap: 16px;
`;

interface IScatterFiltersProps {
    filters: FilterState;
    dispatch: Dispatch<FilterAction>;
}

const ScatterFilters: FC<IScatterFiltersProps> = ({ filters, dispatch }) => {
    const handleCheckboxChange = (filterType: keyof FilterState) => {
        dispatch({ type: "TOGGLE_FILTER", payload: filterType });
        allTrackers.dispatchTrackEvent(
            "Check box",
            filters[filterType] ? "uncheck" : "check",
            `Performance/${filterType === "rising" ? "Rising Competitors" : "New Competitors"}`,
        );
    };

    return (
        <Container>
            <CheckboxFilter
                isDisabled={filters.new}
                isSelected={filters.rising}
                onChange={() => handleCheckboxChange("rising")}
                text={translate("analysis.competitors.search.organic.filter.risingcompetitors")}
                tooltip={translate("analysis.competitors.search.organic.filter.risingcompetitors.tooltip")}
            />
            <CheckboxFilter
                isDisabled={filters.rising}
                isSelected={filters.new}
                onChange={() => handleCheckboxChange("new")}
                text={translate("analysis.competitors.search.organic.filter.newcompetitors")}
                tooltip={translate("analysis.competitors.search.organic.filter.newcompetitors.tooltip")}
            />
        </Container>
    );
};

export default ScatterFilters;
